{
  "accountBlocked": "الحساب محظور",
  "accountInactive": "الحساب غير نشط",
  "alreadyHaveAccount": "لديك حساب بالفعل؟",
  "backToLogin": "العودة لتسجيل الدخول",
  "backupCode": "رمز احتياطي",
  "confirmPassword": "تأكيد كلمة المرور",
  "continue": "متابعة",
  "createAccount": "إنشاء حساب",
  "creatingAccount": "جارٍ إنشاء الحساب...",
  "dontHaveAccount": "ليس لديك حساب؟",
  "email": "البريد الإلكتروني",
  "emailAddress": "البريد الإلكتروني",
  "emailAlreadyExists": "البريد الإلكتروني مستخدم بالفعل",
  "emailNotVerified": "البريد الإلكتروني غير موثّق",
  "enter2FACode": "أدخل رمز التحقق المكوّن من 6 أرقام",
  "forgotPassword": "نسيت كلمة المرور",
  "invalid2FACode": "رمز التحقق غير صحيح",
  "invalidCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  "loggingIn": "جارٍ تسجيل الدخول...",
  "login": "تسجيل الدخول",
  "loginNow": "تسجيل الدخول الآن",
  "loginProtected": "حسابك محمي بواسطة Google Authenticator.",
  "loginRequired": "يرجى تسجيل الدخول لإنشاء تنبيه سعر.",
  "loginSuccessful": "تم تسجيل الدخول بنجاح",
  "logout": "تسجيل الخروج",
  "password": "كلمة المرور",
  "pleaseWait": "يرجى الانتظار...",
  "rememberMe": "تذكرني",
  "resetPassword": "إعادة تعيين كلمة المرور",
  "sendCode": "إرسال الرمز",
  "sending": "جارٍ الإرسال...",
  "sessionExpired": "انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.",
  "signup": "إنشاء حساب",
  "signupNow": "إنشاء حساب الآن",
  "signupSuccessful": "تم إنشاء الحساب بنجاح",
  "twoFactorAuthentication": "التحقق بخطوتين",
  "verify": "تحقق",
  "verify2FA": "التحقق من الرمز الثنائي",
  "verifyEmail": "تحقق من البريد",
  "verifyResetCode": "التحقق من رمز إعادة التعيين"
}